import _ from 'underscore';
import qsc from '../../scripts/util/dom/qsc';
import qs from '../../scripts/util/dom/qs';
import format from 'number-format.js';
import {curry, forEach} from 'ramda';

_.templateSettings = {
	evaluate: /\{\{(.+?)\}\}/g,
	interpolate: /\{\{=(.+?)\}\}/g,
	escape: /\{\{-(.+?)\}\}/g
};

const selectors = {
	template: '#js-amount-template',
	container: '.js-amount-template-container',
	calcDelivery: '.js-amount-calculation-delivery',
	value: '.amount__value',
	calcGiftCard: '.js-amount-calculation-gift-card'
};

const texts = {
	free: 'Бесплатно'
};

const state = {
	total: 0,
	price: 40000,
	gift: 0,
	giftPack: 0,
	delivery: 0,
	method: null
};

const tmpl = qsc(selectors.template);
const container = qsc(selectors.container);

const showDelivery = () => {
	const elem = qs(selectors.calcDelivery);
	if (state.delivery === 0) {
		elem.querySelector(selectors.value).innerHTML = texts.free;
	}
	elem.style.display = 'flex';
};

const showGiftCard = () => {
	const elem = qs(selectors.calcGiftCard);
	elem.style.display = 'flex';
};

const showElem = () => {
	if (state.method) {
		showDelivery();
	}
	if (parseInt(state.gift, 10) > 0) {
		showGiftCard();
	}
};

const updateView = view => {
	container().innerHTML = view;
	showElem();
};

const formatIt = curry(format)('# ##0.##');

const formatField = result => prop => {
	if (prop === 'method') {
		result[prop] = state[prop];
		return;
	}
	result[prop] = formatIt(state[prop]);
};

const formatState = obj => {
	const result = {};
	forEach(formatField(result), Object.keys(obj));
	return result;
};

const updateTotal = () => {
	const build = _.template(tmpl().innerHTML.trim());
	const {delivery, price, gift, giftPack} = state;
	state.total = (delivery + price + giftPack) - gift;
	const a = formatState(state);
	updateView(build(a));
};

const updateDelivery = (method, price) => {
	if (price === texts.free) {
		state.delivery = 0;
	} else {
		state.delivery = parseInt(price, 10);
	}
	state.method = method;
	updateTotal();
};

const updateSum = (param, value) => {
	state[param] = parseInt(value, 10);
	updateTotal();
};

const render = () => {
	const build = _.template(tmpl().innerHTML.trim());
	updateTotal();
	updateView(build(state));
};

export {
	updateSum,
	updateDelivery
};

export default render;





/** WEBPACK FOOTER **
 ** ./app/blocks/amount/controller.js
 **/